import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

// Define the type for the store
type DashboardAccountStore = {
  selectedAccountId: string;
  setSelectedAccountId: (accountId: string) => void;
};

// Define the persist options to explicitly type `selectedColumns`
type DashboardAccountStorePersist = (
  config: StateCreator<DashboardAccountStore>,
  options: PersistOptions<DashboardAccountStore>
) => StateCreator<DashboardAccountStore>;

const useDashboardAccountOptionStore = create<DashboardAccountStore>(
  (persist as DashboardAccountStorePersist)(
    (set: (partial: Partial<DashboardAccountStore>) => void) => ({
      selectedAccountId: '',
      setSelectedAccountId: (accountId: string) => set({ selectedAccountId: accountId }),
    }),
    {
      name: 'dasboard-account-option',
    }
  )
);

export default useDashboardAccountOptionStore;